import { Button, chakra, Box, Flex, HStack, Wrap, Image, Text, Img, Center, useDisclosure } from '@chakra-ui/react';

import React, { useContext } from 'react';
import LogoDashboard from '../../images/petalas-deovita.svg';
import './PerfilEmpresa/css/main.css';
import { useNavigate } from 'react-router-dom';
import { AccountContext } from '../AccountContext';
import Carrinho from '../../images/carrinho.svg';
import DrawerCarrinho from '../Dashboard/Main/Carrinho/DrawerCarrinho';
import CircleCart from './CircleCart';
import { MdCircleNotifications, MdKeyboardArrowLeft } from 'react-icons/md';
import { ArrowBackIcon } from '@chakra-ui/icons';

function NoUserHeader(props) {
  const navigate = useNavigate();
  const { user, page } = useContext(AccountContext);
  let firstName = user.name ? user.name.split(' ') : '';
  const { id_contrato, titular } = user;

  let url = window.location.href;
  const disclosureCarrinho = useDisclosure();
  let message = 'Assine agora!';
  if (user.situacao_contrato === 'P') message = 'Contrato em análise';

  const backgroundColor =
    titular === true && id_contrato === 0
      ? '#5AB2AE'
      : titular === false && id_contrato === 0
      ? '#5AB2AE'
      : titular === true && id_contrato > 0
      ? '#5AB2AE'
      : '#5AB2AE';

  return (
    <>
      <DrawerCarrinho disclosure={disclosureCarrinho} />
      <chakra.header w="full" py={0} shadow="md" backgroundColor={backgroundColor} minHeight="136px" borderBottomRadius="30px">
        <Flex alignItems="center" justifyContent="space-between" mx="auto" ml={{ sm: '40px', base: '10px' }}>
          <Flex direction="column">
            <chakra.h2 fontSize="1em" fontWeight="bold" mt="43px" color="white">
              Este é seu app de saúde
              <br />
            </chakra.h2>
            <Button
              fontSize="12px"
              minH="20px"
              h="auto"
              px={3}
              py={1}
              maxW="100%"
              whiteSpace="normal"
              wordBreak="break-word"
              textAlign="center"
              lineHeight="1.2"
              color={backgroundColor}
              borderRadius={20}
              onClick={() => {
                if (message === 'Assine agora!') {
                  navigate('/cadastro/plano');
                }
              }}
            >
              {message}
            </Button>
          </Flex>
          <Box display={{ base: 'inline-flex' }}>
            <Image
              w="70px"
              h="55px"
              me={{ sm: '30px', base: '10px' }}
              position="absolute"
              right="0.02rem"
              top="43px"
              src={LogoDashboard}
              alt="teste"
            />
          </Box>
        </Flex>

        <Flex direction="row" justifyContent="space-between" alignItems="center" mt="10px">
          <Box
            ml={8}
            onClick={() => {
              props?.home ? navigate('/dashboard') : navigate(-1);
            }}
          >
            <ArrowBackIcon color="#FFF" size={40} />
          </Box>

          <Text fontSize="1em" fontWeight="bold" textColor="white" textAlign="center" width="100%" zIndex="1">
            {page}
          </Text>

          {url.includes('/exames/agendamento') || url.includes('/exames/empresa') ? (
            <>
              <Img
                backgroundColor="#FFF"
                src={Carrinho}
                borderRadius={25}
                w="45px"
                h="25px"
                padding={1}
                onClick={() => disclosureCarrinho.onOpen()}
                color="orange"
                zIndex="101"
                mr={7}
              />

              {user.cart && user.cart.itens ? <CircleCart quantidade={user.cart.itens.length} /> : null}
            </>
          ) : (
            <Box
              mr={7}
              onClick={() => {
                alert('show notification');
              }}
              visibility="hidden"
            >
              <MdCircleNotifications color="#FFF" size={26} />
            </Box>
          )}
        </Flex>
      </chakra.header>
    </>
  );
}

export default NoUserHeader;
